<div class="{{themeService.themeCssClass}}">
    <h4>REGION: {{countrySettingsCode}}</h4>
    <div>
        <div>
            <mat-tab-group #tabChange (selectedTabChange)="tabSelected($event)">
                <mat-tab label="Employees">
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-card class="day-cards green-card"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">NUMBER OF EMPLOYEES
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueEmployees.get('NumOfemployee')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards amber-card"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">FULL TIME EMPLOYEES
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueEmployees.get('fullTime')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">NUMBER OF INTERNS
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueEmployees.get('interns')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards cyan-card"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">FIXED TERM EMPLOYEES
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueEmployees.get('fixedTerm')}}
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button id="newEmp" class="close-button-right"
                                (click)="openNewEmployeePopup()">Create Employee
                        </button>
                    </div>

                    <div>
                        <div fxFlex="100" fxLayoutAlign="center">
                            <mat-form-field appearance="outline">
                                <mat-label>Search (First and Last Name)/GMIN</mat-label>
                                <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                                <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                        (click)="searchValue=''; filterTableDataSources()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div fxFlex="100" fxLayoutAlign="center">
                            <mat-form-field appearance="outline" >
                                <mat-label>Organization</mat-label>
                                <mat-select #EmployeeTeam
                                            (selectionChange)="calculateEmployeesCard(EmployeeTeam.value)"
                                            [(value)]="employeeEntity.teamName" >
                                    <button mat-icon-button (click)="clearEmployeeDropdown('teamName');this.EmployeeTeam.close()"
                                            class="clear-icon">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-option *ngFor="let model of listOfTeamName "
                                                value="{{model}}">{{model}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center">

                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceEmployee" matSort matTableFilter #employeeTable
                                   [exampleEntity]="employeeEntity">
                            <ng-container *ngFor="let field of employeeFieldNames;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="headers" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{employeeDisplayNames[i]}}
                                </th>
                                <td mat-cell *matCellDef="let employee" class="mat-column-standard center-text">
                                    <div *ngIf="field=='gmin' || field=='location' || field=='vacationAllowanceRemaining' || field=='workAbroadAllowanceRemaining' || field=='teamName'"
                                         (click)="openEmployeeDetailsPopup(employee)">
                                        {{employee[field]}}
                                    </div>
                                    <div *ngIf="field!=='gmin' && field!=='startDate' && field!='location' && field!=='vacationAllowanceRemaining' && field!=='workAbroadAllowanceRemaining' && field!=='teamName'&& field!=='contractType'"
                                         (click)="openEmployeeDetailsPopup(employee)">
                                        {{employee[field] |titlecase}}
                                    </div>
                                    <div *ngIf="field=='startDate'"
                                         (click)="openEmployeeDetailsPopup(employee)">
                                        {{employee[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='contractType'" (click)="openEmployeeDetailsPopup(employee)">
                                        {{ employee[field] | titlecase | removeUnderscorePipe }}
                                    </div>
                                    <div *ngIf="field=='editEmployee'">
                                        <button id="editEmployee" class="close-button-right"
                                                (click)="openEditEmployeePopup(employee)">Edit
                                        </button>
                                    </div>
                                    <div *ngIf="field=='override'">
                                        <button id="override" class="close-button-right"
                                                (click)="openOverridePopup(employee)">Override
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="employeeFieldNames; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: employeeFieldNames;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-paginator #employeesPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                </mat-tab>

                <mat-tab label="Vacation">

                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-card class="day-cards green-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Company Annual Leave
                                Entitlement
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.displayValuePersonal.get('leaveEntitlement')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards red-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Remaining Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.displayValuePersonal.get('remainingDays')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards amber-card" *ngIf="!isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.displayValuePersonal.get('pendingDays')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card" *ngIf="!isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Pending Requests
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.displayValuePersonal.get('pendingRequests')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Company Annual Leave
                                Used
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.displayValuePersonal.get('daysUsed')}}
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                        <mat-form-field appearance="outline">
                            <mat-label>Search (First and Last Name)/GMIN</mat-label>
                            <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                            <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchValue=''; filterTableDataSources()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field appearance="outline" *ngIf="isChecked">
                            <mat-label>Year</mat-label>
                            <mat-select #selectedYear
                                        (selectionChange)="calculateDisplayValues(selectedYear.value,selectedTeam.value)"
                                        [(value)]="filterEntity.year">
                                <mat-option *ngFor="let model of year"
                                            value="{{model}}">{{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Organization</mat-label>
                            <mat-select #selectedTeam
                                        (selectionChange)="calculateDisplayValues(filterEntity.year,selectedTeam.value)"
                                        [(value)]="filterEntity.teamName">
                                <button mat-icon-button (click)="clearDropdown('teamName'); this.selectedTeam.close()" class="clear-icon">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-option *ngFor="let model of listOfTeamName " value="{{model}}">
                                    {{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="toggle-box">
                            <mat-label ngClass="labelBeforeSlide">Pending Only</mat-label>
                            <mat-slide-toggle [(ngModel)]="isChecked">All Requests</mat-slide-toggle>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="!isChecked">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceVacation" matSort matTableFilter #personalTable>
                            <ng-container *ngFor="let field of fieldNames;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNames[i]}}
                                </th>
                                <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                                    <div *ngIf="field=='decline'&&vacation['requestStatus']=='PENDING'">
                                        <button id="decline1" class="close-button-right"
                                                (click)="openDeclineVacationPopUp(vacation)">Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='dateCreated'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='startDate'&& stringIOFormat==true">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='endDate' && stringIOFormat==true">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='halfDay'">
                                        {{halfDayStatus(vacation[field])}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays' || field=='absenceReason' && vacation['absenceReason'].length <= 25">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                                         matTooltip="{{vacation[field]}}"
                                         matTooltipPosition="left">
                                        {{vacation[field].slice(0, 25) + '...'}}
                                    </div>
                                    <div *ngIf="field!=='dateCreated' && field!=='startDate' && field!=='endDate' && field!=='halfDay' && field!=='numberOfAnnualLeaveDays'&& field!=='absenceType' && field!=='absenceReason'">
                                        {{vacation[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='absenceType'">
                                        {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                    </div>

                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="!isChecked">
                        <mat-paginator #personalPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="isChecked">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceVacationAll" matSort matTableFilter #personalTableAll
                                   [exampleEntity]="filterEntity">
                            <ng-container *ngFor="let field of fieldNames;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="header-all" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNames[i]}}
                                </th>
                                <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                                    <div *ngIf="field=='decline'&&vacation['requestStatus']=='APPROVED'">
                                        <button id="decline2" class="close-button-right"
                                                (click)="approveCancelRequestForVacation(vacation)">Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='dateCreated'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='startDate'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='endDate'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='halfDay'">
                                        {{halfDayStatus(vacation[field])}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays' || field=='absenceReason' && vacation['absenceReason'].length <= 25">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                                         matTooltip="{{vacation[field]}}"
                                         matTooltipPosition="left">
                                        {{vacation[field].slice(0, 25) + '...'}}
                                    </div>
                                    <div *ngIf="field!=='dateCreated' && field!=='startDate' && field!=='endDate' && field!=='halfDay' && field!=='numberOfAnnualLeaveDays'&& field!=='absenceType' && field!=='absenceReason'">
                                        {{vacation[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='absenceType'">
                                        {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>
                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="isChecked">
                        <mat-paginator #personalPaginatorAll='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <br/>
                    <div fxLayoutAlign="center center" fxLayout="row wrap">
                        <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary"
                                type="button" (click)="exportEmployeeDetailsExcel()">
                            Export Excel
                        </button>
                        <button class="buttons" mat-raised-button color="primary" type="button"
                                (click)="openAbsenceCalendarPopup()">Absence Calender
                        </button>
                    </div>
                </mat-tab>

                <mat-tab label="Work Abroad">
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-card class="day-cards green-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Organization Work Abroad
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueWork.get('leaveEntitlement')}}
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="day-cards red-card resize" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Remaining Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueWork.get('remainingDays')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards amber-card resize" *ngIf="!isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueWork.get('pendingDays')}}
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="day-cards blue-card resize-blue" *ngIf="!isChecked">
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Work Abroad Requests
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueWork.get('pendingRequests')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card resize-blue" *ngIf="isChecked">
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Work Abroad Used
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{displayValueWork.get('daysUsed')}}
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                        <mat-form-field appearance="outline">
                            <mat-label>Search (First and Last Name)/GMIN</mat-label>
                            <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                            <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchValue=''; filterTableDataSources()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field appearance="outline" *ngIf="isChecked">
                            <mat-label>Year</mat-label>
                            <mat-select #yearSelected
                                        (selectionChange)="calculateDisplayValues(yearSelected.value,teamSelected.value)"
                                        [(value)]="filterEntity.year">
                                <mat-option *ngFor="let model of year"
                                            value="{{model}}">{{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" >
                            <mat-label>Organization</mat-label>
                            <mat-select #teamSelected
                                        (selectionChange)="calculateDisplayValues(filterEntity.year,teamSelected.value)"
                                        [(value)]="filterEntity.teamName">
                                <button mat-icon-button (click)="clearDropdown('teamName'); this.selectedTeam.close()" class="clear-icon">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-option *ngFor="let model of listOfTeamName " value="{{model}}">
                                    {{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="toggle-box">
                            <mat-label ngClass="labelBeforeSlide">Pending Only</mat-label>
                            <mat-slide-toggle [(ngModel)]="isChecked">All Requests</mat-slide-toggle>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="!isChecked">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceWork" matSort matTableFilter #workAbroadTable>
                            <ng-container *ngFor="let field of fieldNamesWork;let i=index" matColumnDef="{{field}}">
                                <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesWork[i]}}
                                </th>
                                <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">
                                    <div *ngIf="field=='dateCreated'">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='startDate' && stringIOFormat == true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='startDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat == true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='approve'&&workAbroad['requestStatus']=='PENDING'">
                                        <button id="approve" class="close-button-right"
                                                (click)="approveWork(workAbroad)">
                                            Approve
                                        </button>
                                    </div>
                                    <div *ngIf="field=='decline'&&workAbroad['requestStatus']=='PENDING'">
                                        <button id="decline" class="close-button-right"
                                                (click)="declineWorkAbroad(workAbroad)">
                                            Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='numberOfWorkAbroadDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field !='numberOfWorkAbroadDays' && field !='startDate' && field !='endDate' && field !='dateCreated' && field !='numberOfAnnualLeaveDays'">
                                        {{workAbroad[field]| titlecase}}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesWork; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNamesWork;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="!isChecked">
                        <mat-paginator #workAbroadPaginator='matPaginator'
                                       [pageSize]="10"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="isChecked">
                        <mat-table [dataSource]="dataSourceSwitchWork" matSort matTableFilter #workAbroadAll
                                   [exampleEntity]="filterEntity">
                            <ng-container *ngFor="let field of fieldNamesWorkAllRequest;let i=index"
                                          matColumnDef="{{field}}">
                                <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesWorkAllRequest[i]}}
                                </th>
                                <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">
                                    <div *ngIf="field=='edit'">
                                        <button mat-icon-button matTooltip="Edit" color="primary" (click)="editWorkAbroad(workAbroad)">
                                            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="edit"></mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="field=='workTaken'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='allowanceRemaining'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='teamName'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='startDate' && stringIOFormat == true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='startDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat == true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field !=='numberOfAnnualLeaveDays' && field !=='startDate' && field !=='endDate'  && field !='teamName' && field !=='numberOfWorkAbroadDays' && field !=='workAbroadNegativeCarryOver' && field !=='allowanceRemaining' && field !=='workTaken' && field!=='contractType'">
                                        {{workAbroad[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='numberOfWorkAbroadDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='workAbroadNegativeCarryOver'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='contractType'">
                                        {{ workAbroad[field] | titlecase | removeUnderscorePipe }}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesWorkAllRequest; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: fieldNamesWorkAllRequest;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="isChecked">
                        <mat-paginator #switchWorkAbroadPaginator='matPaginator'
                                       [pageSize]="10"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary"
                                type="button" (click)="exportEmployeeWorkAbroadDetailsExcel()">
                            Export Excel
                        </button>
                    </div>
                </mat-tab>

                <mat-tab label="Public Holidays">
                    <br/>
                    <div>
                        <mat-form-field fxFlex="100" fxLayoutAlign="center" appearance="outline">
                            <mat-label>Year</mat-label>
                            <mat-select #yearValues [(value)]="defaultPlaceHolder"
                                        (valueChange)="fetchPublicHoliday(yearValues.value)">
                                <mat-option *ngFor="let model of yearListInPublicHoliday"
                                            value="{{model}}">{{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourcePublicHoliday" matSort matTableFilter #publicHolidayTable>
                            <ng-container *ngFor="let field of fieldNamesPublicHoli;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="pub-hol-header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard" style="text-align:center">
                                    {{displayNamesPublicHoli[i]}}
                                </th>
                                <td mat-cell *matCellDef="let publicHoliday" class="mat-column-standard center-text">
                                    <div *ngIf="field=='delete'">
                                        <button id="delete" class="close-button-right"
                                                (click)="deletePublicHoliday(publicHoliday.id)">
                                            Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='fixed'">
                                        {{halfDayStatus(publicHoliday[field])}}
                                    </div>
                                    <div *ngIf="field!=='delete' && field !=='fixed' && field !=='halfDay' && field !=='shutdownDay'">
                                        {{publicHoliday[field] |titlecase}}
                                    </div>
                                    <div *ngIf="field=='halfDay' || field=='shutdownDay'">
                                        {{ publicHoliday[field] ? 'Yes' : 'No' }}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesPublicHoli; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: fieldNamesPublicHoli;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-paginator #publicPaginator='matPaginator'
                                       [pageSize]="10"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary"
                                type="button" (click)="exportExcel('publicHoliday')">
                            Export Excel
                        </button>
                        <button id="publicHolidayOpen" class="buttons" type="button" mat-raised-button color="primary"
                                (click)="openNewPublicHolidayPopup(yearValues.value)">New Holiday
                        </button>
                    </div>
                </mat-tab>

                <mat-tab label="Employee Handbook">
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button class="empButtons" mat-raised-button color="primary" type="button" (click)="toggle()"
                                id="bt">{{buttonName}}</button>

                        <a target="_blank" rel="noopener noreferrer" [href]="employeeHandBookPdf.doc"
                           download="EmployeeHandbook">
                            <button class="empButtons" mat-raised-button color="primary" type="button">View PDF
                            </button>
                        </a>
                    </div>
                    <br/>

                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <input id="HrDocs" class="text-tab" name="HRDoc" #employeeHandBook
                               placeholder="Enter URL for Employee Handbook"/>
                        <button id="Employee HandBook" class="buttons" type="button" mat-raised-button color="primary"
                                (click)="updatePdfDocs(employeeHandBook.value)">
                            ENTER PDF
                        </button>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <ng-container *ngIf="show">
                            <div>
                                <mat-card class="urlCard">
                                    <mat-card-content>
                                        <a target="_blank" rel="noopener noreferrer"
                                           [href]="employeeHandBookPdf.doc">{{employeeHandBookPdf.doc}}</a>
                                        <br/>
                                        {{value}}
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab>

                <mat-tab label="Organizations">
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button id="newTeam" class="close-button-right"
                                (click)="openNewTeamPopup()">New Organization
                        </button>
                    </div>

                    <div fxFlex="100" fxLayoutAlign="center">
                        <mat-form-field appearance="outline" (click)="clearSearchBox()">
                            <mat-label>Organization</mat-label>
                            <mat-select #teamTable
                                        (selectionChange)="dataSourceTeam.data = filterTeamsBySelectedTeamName($event.value)"
                                        [(value)]="getTeamName">
                                <input [(ngModel)]="searchTxt" matInput placeholder="{{ searchPlaceholder }}" class="searchBox">
                                <button mat-icon-button (click)="clearTeamDropdown('teamName'); this.teamTable.close()"
                                        class="clear-icon">
                                    <mat-icon>close</mat-icon>
                                    Clear Field
                                </button>
                                <mat-option *ngFor="let model of listOfTeamName | search : searchTxt" value="{{model}}">
                                    {{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceTeam" matSort matTableFilter #teamTable>
                            <ng-container *ngFor="let field of teamFieldNames;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="team-header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard" style="text-align:center">
                                    {{displayTeamFieldNames[i]}}
                                </th>
                                <td mat-cell *matCellDef="let team; let i = index"
                                    class="mat-column-standard center-text">
                                    <div *ngIf="field=='teamName'">
                                        {{team[field]}}
                                    </div>
                                    <div *ngIf="field=='managerName'">
                                        {{team[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='altManagerName'">
                                        {{team[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='edit'">
                                        <button id="edit" class="close-button-right" (click)="openEditTeamPopup(team)">
                                            Edit
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="teamFieldNames; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: teamFieldNames;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-paginator #teamPaginator='matPaginator'
                                       [pageSize]="10"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                </mat-tab>

                <mat-tab label="Workday Import">
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <label for="chooseFileInput" class="close-button-right">
                            Choose a file
                        </label>
                        <input #chooseFileInput type="file" accept=".xlsx" id="chooseFileInput" (change)="chooseFile($event)"/>
                    </div>

                    <div fxLayout="row wrap" fxLayoutAlign="center">
                        <br/>
                        OR
                        <br/>
                        <br/>
                    </div>

                    <div fxLayout="row wrap" fxLayoutAlign="center">
                        <div class="dropzone" DropZone (onFileDropped)="droppedFile($event)">
                            <div style="border: dotted #0074D9; padding: 8em;"
                                 ondragover="this.style.padding='8.5em';"
                                 ondragleave="this.style.padding='8em';"
                                 ondrop="this.style.padding='8em';">
                                Drag and drop files here
                                <br/>
                                <em fxLayoutAlign="center" class="material-icons">&#xe2c6;</em>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="file || isPageLoading || importCompleted" fxLayout="row" fxLayoutAlign="center">
                        <br/>
                        <p id="fileNameField" *ngIf="file">{{ file.name }}</p>
                        <button class="buttons" type="button" mat-raised-button color="primary" 
                                *ngIf="!isPageLoading && !importCompleted"
                                (click)="file=''; chooseFileInput.value=''; exportAvailable=false; importCompleted=false">Remove</button>
                        <button class="buttons" type="button" mat-raised-button color="primary" 
                                *ngIf="!isPageLoading && !importCompleted"
                                (click)="submitExcel()">Submit</button>
                        <button class="buttons" type="button" mat-raised-button color="primary" 
                                *ngIf="importCompleted"
                                (click)="file=''; chooseFileInput.value=''; exportAvailable=false; importCompleted=false; handleExportExcel=[]; chooseFileInput.click()">Choose Another File</button>
                    </div>

                    <!-- Import loading indicator -->
                    <div *ngIf="isPageLoading" fxLayout="row" fxLayoutAlign="center" class="import-loading-container">
                      <mat-card style="width: 100%; margin: 20px;">
                        <mat-card-title>Processing Import</mat-card-title>
                        <mat-card-content>
                          <div fxLayout="row" fxLayoutAlign="center" style="margin: 20px 0;">
                            <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
                          </div>
                          <p style="text-align: center;">Please wait while your file is being processed...</p>
                        </mat-card-content>
                      </mat-card>
                    </div>


                    <!-- Import success indicator -->
                    <div *ngIf="importCompleted && handleExportExcel.length === 0" fxLayout="row" fxLayoutAlign="center" class="import-success-container">
                      <mat-card class="success-card" style="width: 100%; margin: 20px;">
                        <mat-card-title style="color: #4caf50;">
                          <mat-icon style="color: #4caf50; vertical-align: middle;">check_circle</mat-icon>
                          Import Successful
                        </mat-card-title>
                        <mat-card-content>
                          <p style="text-align: center;">Your file has been processed successfully. All employee data has been imported without errors.</p>
                        </mat-card-content>
                      </mat-card>
                    </div>

                    <!-- Import error indicator -->
                    <div *ngIf="importCompleted && handleExportExcel.length > 0" fxLayout="row" fxLayoutAlign="center" class="import-error-container">
                      <mat-card class="error-card" style="width: 100%; margin: 20px;">
                        <mat-card-title style="color: #f44336;">
                          <mat-icon style="color: #f44336; vertical-align: middle;">error</mat-icon>
                          Import Completed with Errors
                        </mat-card-title>
                        <mat-card-content>
                          <p style="text-align: center;">
                            Your file has been processed, but {{handleExportExcel.length}} rows contained errors and were not imported.
                          </p>
                          <p style="text-align: center;">
                            You can download the error rows to review and fix the issues, then try importing again.
                          </p>
                          <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="10px" style="margin-top: 15px;">
                            <button class="buttons" type="button" mat-raised-button color="warn" 
                                    (click)="downloadErrorRows()">
                              Download Error Rows
                            </button>
                            <button class="buttons" type="button" mat-raised-button color="primary" 
                                    (click)="file=''; chooseFileInput.value=''; exportAvailable=false; importCompleted=false; handleExportExcel=[]">
                              Import Another File
                            </button>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                </mat-tab>

            </mat-tab-group>
        </div>
    </div>
    <fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
</div>

